<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed } from 'vue';

const { layoutConfig, isDarkTheme } = useLayout();

const logoUrl = computed(() => {
    if (!isDarkTheme.value) {
        return `/images/dark_outpost_logo.png`;
    } else {
        return `/images/light_outpost_logo.png`;
    }
});

const version = computed(() => {
    const metaVersion = document.querySelector("meta[name='release:version']")
    if (metaVersion) {
        return metaVersion.getAttribute('content')
    }
});

</script>

<template>
    <div class="layout-footer">
        <img :src="logoUrl" alt="Logo" height="20" class="mr-2" />
        <div class="flex text-secondary font-italic text-xs">
            {{ version }}
        </div>
    </div>
</template>
<style lang="scss" scoped></style>
